// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30CSG","col":"styles_col__22tI5"};